var _rect, _path, _rect2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "transparent",
    x: 16,
    y: 11,
    width: 5,
    height: 8,
    rx: 2.5,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M10 23C16.4046 23 17.9457 21.4937 18 20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "transparent",
    x: 1,
    y: 11,
    width: 5,
    height: 8,
    rx: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12V16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12V16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M21 12C21 9.08262 19.9464 6.28473 18.0711 4.22183C16.1957 2.15893 13.6522 1 11 1C8.34784 1 5.8043 2.15892 3.92893 4.22182C2.05357 6.28472 1 9.08262 1 12",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarphones);
export default __webpack_public_path__ + "static/media/earphones.549e1fdbc6f5a7543929509f6e963aae.svg";
export { ForwardRef as ReactComponent };